import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useCallback } from 'react';

import { MyWorkPage } from '@/pages/my-work/my-work-page';
import { parseMyWorkSearch, type MyWorkSearch } from '@/pages/my-work/my-work-search';

/**
 * `/my/work?view=today|unplanned|later|all&role=&status=&priority=&due=&project=&team=&sort=`
 *
 * My Work — one adaptive page for desktop and phone (§4 W3-B). All params
 * are optional and tolerant (bad values are dropped); the default view is
 * Today. Deep-linkable: `/my/work?view=all&status=review` opens All filtered.
 */
function MyWorkRoute() {
  const search = Route.useSearch();
  const navigate = useNavigate();
  const onSearchChange = useCallback(
    (next: MyWorkSearch) => void navigate({ to: '/my/work', search: next, replace: true }),
    [navigate],
  );
  return <MyWorkPage search={search} onSearchChange={onSearchChange} />;
}

export const Route = createFileRoute('/my/work')({
  validateSearch: (raw: Record<string, unknown>): MyWorkSearch => parseMyWorkSearch(raw),
  component: MyWorkRoute,
});
